jQuery(function($) {
  

    /*************/
    /* VAR */
    /*************/
    var LARGEUR_MAX_MOBILE = 1024;

  /* **************************************************  */
  /* HEADER DROPDOWN */
  /* **************************************************  */
  
  $('.to_nicedropdown-js').niceSelect();


  /* **************************************************  */
  /* SLIDER AUTRES NEWS */
  /* **************************************************  */

  $('.OtherPost-Slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows:false
  });
 

  /* **************************************************  */
  /* ACCORDEON FAQ  */
  /* **************************************************  */
   // .not( "#question_1" )
   $('.accordion-section-content').hide();
//   $('#question_1').parent().addClass('active');

   //$('.accordion-section-content').hide();
    // ACCORDEON SECTION 
    function close_accordion_section() {
        $('.accordeon-page .accordion-section-title').removeClass('active');
        $('.accordeon-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
      
         $('.accordeon-page .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).slideUp(300);
         $('.accordeon-page .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            // Open up the hidden content panel
            $('.accordeon-page ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //
    ////////////////////


  /* **************************************************  */
  /* SLIDER TEMOIGNAGES */
  /* **************************************************  */
  var $current_number = $('.current_number');
   $('.Testimony-Slider--js').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows:true,
      nextArrow: '.next_historic',
      prevArrow: '.prev_historic',
       responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows:true,
            dots: true,
            nextArrow: '.next_historic',
            prevArrow: '.prev_historic'
          }
        }
     ]
      // more settings
  });

   $('.Testimony-Slider--js').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $current_number.text(parseInt(nextSlide+1));
  });

    // /*  ***************************
  // TEAM MEMBER
  // ******************************** */
  $('.PeTeam-Item-Desc').hide();
  $( ".PeTeam-Item-js" ).click(function() {

    var $ElttoShow = $(this).find('.PeTeam-Item-Desc');


  if($(this).attr('aria-expanded') == 'false'){


    $( ".PeTeam-Item" ).each(function( index ) {
      if($(this).hasClass('open')){
           $(this).removeClass('open').attr('aria-expanded', false);
           $(this).find('.PeTeam-Item-Desc').slideUp(500);
      }
    });


    $(this).attr('aria-expanded', true);
    $(this).addClass('open');

    $ElttoShow.slideDown(500, function(){
      // $('.ss-content').animate({
      //     scrollTop: 290//$("#home_more").offset().top - 200
      // },'slow');
      
    });

  }else{
    $(this).removeClass('open');
    $(this).attr('aria-expanded', false);
     
     $ElttoShow.slideUp(500, function(){
     
     });
  }
});



  /* **************************************************  */
  /* SLIDER HISTORIC */
  /* **************************************************  */

  $('.Historic-Slider-js').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows:true,
  nextArrow: '.next_historic',
  prevArrow: '.prev_historic',
   responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:true,
            dots: false,
             nextArrow:'<button type="button" class="slick-next">Next</button>',
            prevArrow:'<button type="button" class="slick-prev">Previous</button>'
          }
        }
     ]
    // more settings
  });
  $('.Historic-Slider-js .Historic-Item').click(function(e) {
   e.preventDefault();
   slideIndex = $(this).index();
  // var slideno = $(this).data('slide');
  console.log(slideIndex);
   $('.Historic-Slider-js').slick('slickGoTo', parseInt(slideIndex - 1));
 });


   


 // slider.slick(settings);
//   slick_on_mobile( $slick_slider, settings_slider);

// // slick on mobile
//   function slick_on_mobile(slider, settings){
//     // $(window).on('load resize', function() {
//     //   if ($(window).width() > 767) {
//     //     if (slider.hasClass('slick-initialized')) {
//     //       slider.slick('unslick');
//     //     }
//     //     return
//     //   }
//       // if (!slider.hasClass('slick-initialized')) {
//         return 
//       // }
//     });
//   };



      // /*  ***************************
  //  SLIDER TOP ACCUEIL
  // ******************************** */

    $('.HomeIntroSlider-js').slick({
        //setting-name: setting-value
      //  dots: true,
       // infinite:true,
        arrows:true,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:900,
        fade: true,
        pauseOnHover:false,
        pauseOnFocus:false,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows:false,
            dots: true
        }
       }
      ]
   });




/*  ***************************
  SLIDE BLOCK !!
******************************** */


 /* Gallerie SLIDER POST RELATED */
$('.SlideBloc-Inner-js').slick({
      //setting-name: setting-value
      dots: false,
      arrows:true,
      speed:1400,
      infinite:true,
      slidesToShow: 2,
      slidesToScroll: 1,
      nextArrow: '.next_news',
      prevArrow: '.prev_news',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            nextArrow:'<button type="button" class="slick-next">Next</button>',
            prevArrow:'<button type="button" class="slick-prev">Previous</button>',
            arrows:true,
            dots: false
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:true,
            dots: false,
             nextArrow:'<button type="button" class="slick-next">Next</button>',
            prevArrow:'<button type="button" class="slick-prev">Previous</button>'
          }
        }
     ]
}).on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});




  /* **************************************************  */
  /* SLIDER APPLICATION / HOME / DOMAINES ETC.. ONLY ON MOBILE */
  /* **************************************************  */

  $slick_slider = $('.SlickOnMobile');
  settings_slider = {
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows:true,
  dots: false,
  responsive: [
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows:true,
      dots: false,
      }
    }
  ]
    // more settings

  };

  slick_on_mobile( $slick_slider, settings_slider);

// slick on mobile
  function slick_on_mobile(slider, settings){
    $(window).on('load resize', function() {
      if ($(window).width() > 768) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return;
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  }


 /////////////////////////////////////
   //////// CLICK ON SEARCHTAB ////////
  var $btn_close_form = $('.js-close-form');
  var $btn_open_mobile = $('.js-mobile-open-search');
   $('li.item_search > a, .js-mobile-open-search').on('click', function(evt) { // Au clic sur un élément
    
    $('body').toggleClass('toggle_search'); // Go
    
    if($btn_close_form.attr('aria-expanded') == 'false'){
       $btn_close_form.attr('aria-expanded','true');
    }else{
      $btn_close_form.attr('aria-expanded','false');
    }

     if($btn_open_mobile.attr('aria-expanded') == 'false'){
       $btn_open_mobile.attr('aria-expanded','true');
    }else{
      $btn_open_mobile.attr('aria-expanded','false');
    }

      evt.preventDefault();
    });

   /// CLOSE SEARCH 
    $( ".js-close-form" ).click(function( ) {
          $(this).attr('aria-expanded','false');
          $('body').toggleClass('toggle_search'); // Go
  });



   /////////////////////
  /// MENU MOBILE /////

     // var ElementSlider = $('.GalleryTopHome');
  var Header = $('#masthead');
  var menu_mobile = $('#primary-menu').clone();
  // var form_search = $(".SearchformTop-Inner").clone();
  // form_search.addClass('for_menu_mobile');

  //    var menu_secondaire = $("#footer-menu li").clone();
  //    menu_mobile.append(menu_secondaire);

  //   // menu_mobile.append(menu_rs);
  menu_mobile.slicknav({
      duration:300,
      prependTo : "#masthead",
      beforeOpen:move_body,
      beforeClose:move_body,
      openedSymbol:">",
      closedSymbol:">"
    });

  

  function move_body(){

    if($('.slicknav_btn').hasClass('slicknav_open')){
      $('body').addClass('move_to_right');
    }else{
      $('body').removeClass('move_to_right');
    }
  }



    var position_top_menu_page = $("#primary-menu").offset().top;
  $( window ).resize(function() {
      position_top_menu_page = $("#primary-menu").offset().top;
  });

    /*************/
    /* SCROLL MENU HOME  */
    /*************/
   
      $(window).scroll(function () {
        action_on_scroll_page();
    });
 
  

  function active_fixed_menu(){
    $("body").addClass('to_fixed_menu'); 
  }

  function remove_fixed_menu(){
    $("body").removeClass('to_fixed_menu');
  }


  function action_on_scroll_page(){

    var l_window = parseInt($(window).width());
    
    //h_header = $("#masthead").height();

    if (l_window > LARGEUR_MAX_MOBILE){
       if ($(window).scrollTop() > position_top_menu_page){
          active_fixed_menu();
        }else{
          remove_fixed_menu();
        }
    }else{

    }
 }




  /* *****************  */
    /* CONTACT FORM 
  /* *****************  */

  // Formulaire de contact ///
   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form input[type='tel'], .wpcf7-form select" ).click(function() {
      $( this ).parent().parent().addClass('focus');
  });

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form textarea, .wpcf7-form select" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form input[type='text'],.wpcf7-form textarea, .wpcf7-form select" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });
    



    // ECLATE //


  var l_window = $(window).width();
  var tween,$offset,$duration_1,$duration_3,$duration_4,$duration_5,$duration_6;


    // LAYER 1 //

    if (l_window > 1024){

    var controller = new ScrollMagic.Controller();


    if(l_window > 1300) {
       $offset = 0;
       $duration_1 = 50;
       $duration_3 = 220;
       $duration_4 = 330;
       $duration_5 = 550;
       $duration_6 = 780;
    } else {
       $offset = -20;
       $duration_1 = 50;
       $duration_3 = 200;
       $duration_4 = 350;
       $duration_5 = 600;
       $duration_6 = 800;
    }
    

    new ScrollMagic.Scene({triggerElement: "#trigger", duration: $duration_1,offset: $offset})
      .setPin("#layer_1")
      .setClassToggle("#layer_1", "no_active")
      //.addIndicators() // add indicators (requires plugin)
      .addTo(controller)
      .on("progress", function (e) {
          if (parseInt(e.progress) == 1){
            $("#layer_1").addClass('active');
          }else{
            $("#layer_1").removeClass('active');
          }
            
        })
      ;

    

      new ScrollMagic.Scene({triggerElement: "#trigger", duration: $duration_3,offset: $offset})
      .setPin("#layer_2")
      .setClassToggle("#layer_2", "no_active")
      //.addIndicators() // add indicators (requires plugin)
      .addTo(controller)
      .on("progress", function (e) {
          if (parseInt(e.progress) == 1){
            $("#layer_2").addClass('active');
          }else{
            $("#layer_2").removeClass('active');
          }
            
        })
      ;

      new ScrollMagic.Scene({triggerElement: "#trigger", duration: $duration_4,offset: $offset})
      .setPin("#layer_3") 
      .setClassToggle("#layer_3", "no_active")
      //.addIndicators() // add indicators (requires plugin)
      .addTo(controller)
      .on("progress", function (e) {
          if (parseInt(e.progress) == 1){
            $("#layer_3").addClass('active');
          }else{
            $("#layer_3").removeClass('active');
          }
            
        })
      ;


      new ScrollMagic.Scene({triggerElement: "#trigger", duration: $duration_5,offset: $offset})
      .setPin("#layer_4")
      .setClassToggle("#layer_4", "no_active")
      //.addIndicators() // add indicators (requires plugin)
      .addTo(controller)
      .on("progress", function (e) {
          if (parseInt(e.progress) == 1){
            $("#layer_4").addClass('active');
          }else{
            $("#layer_4").removeClass('active');
          }
            
        })
      ;

          //OVERLAY 1
          new ScrollMagic.Scene({triggerElement: "#trigger", duration: $duration_5,offset: $offset})
          .setPin("#overlay-1")
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller);

          //OVERLAY 1
          new ScrollMagic.Scene({triggerElement: "#trigger", duration: $duration_5,offset: $offset})
          .setPin("#overlay-2")
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller);


      new ScrollMagic.Scene({triggerElement: "#trigger", duration: $duration_6,offset: $offset})
      .setPin("#layer_5")
      .setClassToggle("#layer_5", "no_active")
      //.addIndicators() // add indicators (requires plugin)
      .addTo(controller)
      .on("progress", function (e) {
          if (parseInt(e.progress) == 1){
            $("#layer_5").addClass('active');
          }else{
            $("#layer_5").removeClass('active');
          }
            
        })
      ;

    }


 });